import routerOptions0 from "/root/workspace/easygif-nuxt_6hOg/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.30_better-sqlite3@11.10.0_db0@0.3.2_51eb4f24f87f0a93947557f944077068/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}